<template>
  <div>
    <base-header class="pb-6  bg-gradient-info">
    <div style="min-height:30px;"></div>
    
    
      <div v-if="0" class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">Default</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
        <div class="col-lg-6 col-5 text-right">
          <base-button size="sm" type="neutral">New</base-button>
          <base-button size="sm" type="neutral">Filters</base-button>
        </div>
      </div>
      
      
      <!-- Card stats -->
      <div class="row">
        <div class="col-xl-3 col-md-6">
          <stats-card title="AGM Deadline"
                      type="gradient-red"
                      :sub-title="dates.agm_deadline_str"
                      icon="fa fa-gavel">

            <template slot="footer">
             <span v-if="dates.days_to_agm_deadline=='x'">
             		<span class="text-nowrap">Past deadline</span>
             </span>
              
              <span v-else-if="dates.days_to_agm_deadline=='-'">
              		<span class="text-success mr-2"><i class="fa fa-clock"></i> AGM Held</span>
              </span>
              
              <span v-else>
              	
              		<span v-if="dates.days_to_agm_deadline<150" class="text-danger mr-2"><i class="fa fa-clock"></i> {{dates.days_to_agm_deadline}}</span>
              		<span v-else class="text-success mr-2"><i class="fa fa-clock"></i> {{dates.days_to_agm_deadline}}</span>
              		<span class="text-nowrap">days to deadline</span>
                            	
              </span>
              
              
            </template>
          </stats-card>
        </div>
        <div class="col-xl-3 col-md-6">
          <stats-card title="Annual Return Deadline"
                      type="gradient-red"
                      :sub-title="dates.ar_deadline_str"
                      icon="fa fa-gavel">

            <template slot="footer">
              <span class="text-danger mr-2"><i class="fa fa-clock"></i> {{dates.days_to_ar_deadline}}</span>
              
              <span v-if="dates.days_to_ar_deadline_is_count==1" class="text-nowrap">days to deadline</span>
              
            </template>
          </stats-card>
        </div>
        <div class="col-xl-3 col-md-6">
          <stats-card title="ECI Deadline"
                      type="gradient-red"
                      :sub-title="dates.eci_deadline_str"
                      icon="fa fa-file-invoice-dollar">

            <template slot="footer">
             <span v-if="dates.days_to_eci_deadline=='x'">
             		<span class="text-nowrap">Past deadline</span>
             </span>
             <span v-else>
             	 <span class="text-success mr-2" v-if="dates.days_to_eci_deadline>150"><i class="fa fa-clock"></i> {{dates.days_to_eci_deadline}}</span>
              	 <span class="text-danger mr-2" v-else><i class="fa fa-clock"></i> {{dates.days_to_eci_deadline}}</span>
              	<span class="text-nowrap">days to deadline</span>
           	</span>
            </template>
          </stats-card>

        </div>
        <div class="col-xl-3 col-md-6">
         <!-- <stats-card title="Form C-S/ C Deadline"
                      type="gradient-red"
                      :sub-title="dates.form_cs_date_str"
                      icon="fa fa-file-invoice-dollar">

            <template slot="footer">
            	 <span v-if="dates.days_to_form_cs_deadline=='x'">
             		<span class="text-nowrap">Past deadline</span>
             </span>
             <span v-else>
            
            	  <span class="text-success mr-2" v-if="dates.days_to_form_cs_deadline>150"><i class="fa fa-clock"></i> {{dates.days_to_form_cs_deadline}}</span>
             	  <span class="text-danger mr-2" v-else><i class="fa fa-clock"></i> {{dates.days_to_form_cs_deadline}}</span> 
             	 <span class="text-nowrap">days to deadline</span>
              
              </span>
            </template>
          </stats-card>-->
        </div>
      </div>
    </base-header>

    <!--Charts-->
    <div class="container-fluid mt--6">
      <div class="row">
      
      
       <div class="col-xl-4">
          <card header-classes="bg-transparent">
            <div slot="header" class="row align-items-center">
              <div class="col text-center">
                <h3 class="h3">Company Details</h3>
              </div>
            </div>

            <div>
                <span class="h6 surtitle">Company Name</span>
                <div class="h3 ">{{entity.entity_name}}</div>
             </div>
             
             <div style="margin-top:30px;">
                <span class="h6 surtitle">UEN Number</span>
                <div class="h3 ">{{entity.uen}}</div>
             </div>
             
             
              <div style="margin-top:30px;">
                <span class="h6 surtitle">Financial Year-End</span>
                <div class="h3 ">{{dates.fye_str}}</div>
             </div>
             
             
             
             <div style="margin-top:30px;">
                <span class="h6 surtitle">Date Of Incorporation</span>
                <div class="h3 ">{{entity.date_incorp_str}}</div>
             </div>
             
             
             <div style="margin-top:30px;">
                <span class="h6 surtitle">Registered Address</span>
                <div class="h4">{{entity.registered_address}}</div>
             </div>
             
             
              
             
             
              <div style="margin-top:30px;">
                <span class="h6 surtitle">Nature Of Business</span>
                <div class="h4 ">
                	<span v-if="entity.principal_activity_1_desc">{{entity.principal_activity_1_desc}}</span>
                    <span v-else-if="entity.principal_activity_1_title">{{entity.principal_activity_1_title}}</span>
                </div>
             </div>
          
          
          </card>
        </div>
       <!-- end column --> 
        
        
        
        <div class="col-xl-8">
          <card >
         <div slot="header" class="row align-items-center">
              <div class="col text-center">
                <h3 class="h3">Notifications</h3>
              </div>
            </div>
			<div style="min-height:350px;">
			 <base-alert v-if="passed_fye==1"  type="warning" icon="ni ni-like-2">
          		 <i class="ni ni-time-alarm"></i>   <strong> Notice. </strong> The current financial year has ended. Please schedule your AGM.
            </base-alert>	
			 <base-alert v-if="!verified" type="danger" icon="ni ni-like-2">
          		 <i class="fa fa-exclamation-circle"></i><span  @click="resendVerifyEmail" style="cursor:pointer;"> Please verify your email address. Click to resend the verification email. </span>
            </base-alert>	
			
			
			
			
			</div>
           <!-- end card body-->
         
        
          </card>
        </div>

       
      </div>
      <!-- End charts-->

      <!--start new row-->
      <div class="row">
        <div class="col-xl-4">
          <card v-for="s in secretary" gradient="success"  :key="s.id">

         
              <div class="">
                  <span class="h6 surtitle text-white">
                    Company Secretary
                  </span>
                <div class="h3" style="color:#fcfcfc">{{s.name}}</div>
              </div>
              <div class="row" style="margin-top:30px;">
                <div class="col">
                  <span class="h6 surtitle" style="color:#fcfcfc">Contact Number</span>
                  <span class="d-block h3 text-white">{{s.contact_num}}</span>
                </div>
              </div>

            </card>
            
            
             <div class="card">
					<div class="card-header  bg-gradient-default" >
					  <div class="row align-items-center">
						<div class="col-sm-8">
						  <h3 class="mb-0 text-white">Company Contact Person</h3>
						</div>
						<div class="col text-right">
						  <base-button @click="goEditContactPerson" size="sm" type="primary">Edit</base-button>
						</div>
					  </div>
					</div>
					<div class="card-body">
						
						 <div class="row">
						 <div class="col-md-12" style="">
							<span class="h6 surtitle">Full Name</span>
							<div class="h3 ">{{contact_person.first_name}} {{contact_person.last_name}}</div>
						 </div>
						 
						 
						
						 </div>
						 <div class="row">
						 
						 <div class="col-md-6" style="margin-top:30px;">
							<span class="h6 surtitle">Contact Number</span>
							<div class="h3 ">{{contact_person.contact_number}}</div>
						 </div>
						 
						  <div class="col" style="margin-top:30px;">
							<span class="h6 surtitle">Email Address</span>
							<div class="h3 ">{{contact_person.email}}</div>
						 </div>
						 </div>
						 
						 <div class="row" style="margin-top:30px;">
						 
							 <div  class="col"  style="">
								<span class="h6 surtitle">Position</span>
								<div class="h3 ">
									<span v-if="contact_person.position=='d'">Director</span>
									<span v-if="contact_person.position=='s'">Shareholder</span>
									<span v-if="contact_person.position=='ds'">Director & Shareholder</span>
									<span v-if="contact_person.position=='c'">Contact Person /  Agent</span>
							
								</div>
							 </div>
						 
						 
						 </div><!-- end row-->
						 
					
					
            		</div>
            </div><!-- end card -->
        </div>  <!--End column-->
        
        <div class="col-xl-8">
        
        	<div v-if="accounts!=0" class="card">
					<div class="card-header  bg-gradient-default" >
					  <div class="row align-items-center">
						<div class="col-sm-8">
						  <h3 class="mb-0 text-white">Financials</h3>
						</div>
						<div class="col text-right">
						</div>
					  </div>
					</div>
					<div class="card-body">
						
						 <div class="row">
						 <div class="col-md-12" style="">
							<span class="h6 surtitle">{{accounts.bs.reportTitle}}</span>
							<div v-html= "accounts.bs.output" ></div>
						 </div>
						 </div>
						 
						 
						  <div class="row">
						 <div class="col-md-12" style="margin-top:70px;">
							<span class="h6 surtitle">{{accounts.pl.reportTitle}}</span>
							<div v-html= "accounts.pl.output" ></div>
						 </div>
						 </div>
						 
						
					
					
            		</div>
            </div><!-- end card -->
        
        
        </div> <!-- end column -->
        
        
      </div>
      <!--End row-->

      <!--Widgets-->
      <div class="row">
        <div class="col-xl-5">
        
        </div>
        <div class="col-xl-7">
         
        </div>
      </div>
      <!--End Widgets-->

      <!--Tables-->
      <div class="row">
        <div class="col-xl-8">
        
        </div>
        <div class="col-xl-4">
         
        </div>
      </div>
      <!--End tables-->
    </div>
    
    
    <div style="min-height:200px;"></div>

  </div>
</template>
<script>

  import ApiService from '@/services/api.service';
  import { TokenService } from '@/services/storage.service'
  
  import swal from 'sweetalert2';
  import 'sweetalert2/dist/sweetalert2.css';

  export default {
    components: {
  
    },
    data() {
      return {
      	dates:[],
      	entity:[],
      	secretary:[],
      	accounts:{
      		bs:[],
      		pl:[],
      	},
      	verified:1,
      	passed_fye:0,
        contact_person:{
      		first_name:'-',
      		last_name:'',
      		contact_number:'-',
      		email:'-',
      		position:'-',
      	}

      };
    },
    methods: {
      goEditContactPerson(){
      
      	this.$router.push( '/edit-contact-person');
      
      },
      resendVerifyEmail(index) {
          swal.showLoading();
      	 let uri = this.$base_url+'/api/v1/c/resend_verify_email'
         ApiService.get(uri).then(response => {
         	  swal.fire({
						title: `Success`,
						text: 'Verification email resent. If you have not seen it, please check your spam or junk folder. ',
						buttonsStyling: false,
						confirmButtonClass: 'btn btn-success',
						icon: 'success'
				 });
         	
   
      	})

      }
    },
    mounted() {
    	swal.showLoading();
      
		const client_info = JSON.parse(TokenService.getUserInfo());
      	let uri = this.$base_url+'/api/v1/c/get_my_entity_dashboard/'+ client_info.entity_id;
         ApiService.get(uri).then(response => {
         	
      		 const vm = this;
      		 this.dates = response.data.dates;
      		 this.entity = response.data.entity;
      		 this.secretary = response.data.secretary;
      		 this.verified = response.data.verified;
      		 this.passed_fye = response.data.passed_fye;
      		 this.accounts = response.data.accounts;
      		 
      		 if(response.data.contact_person){
      		 	this.contact_person = response.data.contact_person;
      		 }
      		 swal.close();
   
      	})
      	
      	
    }
  };
</script>
<style lang="scss">
@media screen and (max-width: 820px) {
	.ec_company_header_mob{
		display:none;
	}	
}



</style>














